import React from 'react'

export default function ErrorPage({error}:any) {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{height: 'calc(100vh - 10.5rem)'}}>
            <h4>{error}</h4>
        </div>
    )
}
